import React from 'react';

const PurchasesDocsTab = ({ isCollapsed }) => {
    return (
        <section className={`page-content ${isCollapsed === null ? '' : isCollapsed ? 'page-content_collapsed' : 'page-content_full-width'}`}>
            <article className="users">
                <div className="clients-table clients-table--purchase-docs">
                    <div className="clients-table__header">
                        <div className="clients-table__row">
                            <div className="clients-table__cell" style={{ gridColumn: '1 / -1' }}>
                                Документы закупки (пусто)
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    );
};

export default PurchasesDocsTab;
